import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchMyProfileDetails } from '../settings/myprofile/MyProfileActions';
import NotFound from '../notfound/NotFound';
import { getSiteByLink } from './CustomSiteActions';
import ContactUsSection from '../homepage/sections/ContactUsSection';

const CONTACT_URL = 'contact-us';
const TERMS_AND_CONDITIONS_URL = 'terms-and-conditions';

function CustomSite({ onNotFound }) {
  const [content, setContent] = useState({});
  const [showNotFound, setShowNotFound] = useState(false);

  const notFound = useCallback(() => {
    setShowNotFound(true);
    if (onNotFound) onNotFound(true);
  }, [onNotFound]);

  const dispatch = useDispatch();
  const location = useLocation();
  const link = location.pathname.substring(1);
  const isAuthenticated = useSelector((state) => state.auth.get('isAuthenticated'));

  useEffect(() => {
    if (link === CONTACT_URL && isAuthenticated) {
      dispatch(fetchMyProfileDetails());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, link]);

  useEffect(() => {
    setShowNotFound(false);
    if (onNotFound) onNotFound(false);
    setContent('');
    dispatch(getSiteByLink(link, setContent, notFound));
  }, [dispatch, link, notFound, onNotFound]);

  const render = () => {
    if (link === CONTACT_URL) {
      return <ContactUsSection />;
    }
    if (link === TERMS_AND_CONDITIONS_URL) {
      return (
        <>
          {/* eslint-disable-next-line react/no-danger */}
          <div
            dangerouslySetInnerHTML={{ __html: content?.content }}
            className="custom-site__content"
          />
        </>
      );
    }
    return content ? (
      <>
        {/* eslint-disable-next-line react/no-danger */}
        <div
          dangerouslySetInnerHTML={{ __html: content?.content }}
          className="custom-site__content"
        />
      </>
    ) : (
      ''
    );
  };

  return showNotFound ? (
    <NotFound />
  ) : (
    <div className="custom-site__outer-wrapper">
      <div className="custom-site__inner-wrapper">
        {link !== CONTACT_URL && <h2 className="custom-site__title">{content?.title}</h2>}
        {render()}
      </div>
    </div>
  );
}

export default CustomSite;
